import { render, staticRenderFns } from "./destinationPortCode.vue?vue&type=template&id=5a69d168&"
import script from "./destinationPortCode.vue?vue&type=script&lang=js&"
export * from "./destinationPortCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a69d168')) {
      api.createRecord('5a69d168', component.options)
    } else {
      api.reload('5a69d168', component.options)
    }
    module.hot.accept("./destinationPortCode.vue?vue&type=template&id=5a69d168&", function () {
      api.rerender('5a69d168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/uiCustom/se/cargoDoc/destinationPortCode.vue"
export default component.exports